import { AppData, ResturantData } from "@/types/globalTypes";
import { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { FaWhatsapp, FaWifi } from "react-icons/fa";
import toast from "react-hot-toast";
import { FaGear } from "react-icons/fa6";
import axios from "axios";
import { useSelector } from "react-redux";
import QRCodeStyling from "qr-code-styling";
import { Skeleton } from "../ui/skeleton";
import Heading from "@tiptap/extension-heading";
import { EditorContent, useEditor } from "@tiptap/react";
import Highlight from '@tiptap/extension-highlight';
import BulletList from "@tiptap/extension-bullet-list";
import OrderedList from "@tiptap/extension-ordered-list";
import ListItem from "@tiptap/extension-list-item";
import StarterKit from "@tiptap/starter-kit";
import Bold from "@tiptap/extension-bold";
import { MdOutlineWifiOff } from "react-icons/md";
import ToggleSwitch from "../ToggleSwitch";

import WhatsappMessage from "../CashierMessage/WhatsappMessage";
import Toolbar from "./Toolbar";
import { Placeholder } from "./Placeholder";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";
import useLockBodyScroll from "@/hooks/useLockBodyScroll";

type WhatsAppNotifierAppProps = {
  app: AppData;
  isPending: boolean;
  installApp: (appName: string) => void;
  uninstallApp: (appName: string) => void;
};
type Message = {
  id: number;
  name: string;
  content?: string;
  time?: number
  event?: string
}



function WhatsAppNotifierApp({
  app,
  isPending,
  installApp,
  uninstallApp,
}: WhatsAppNotifierAppProps) {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [newMessageName, setNewMessageName] = useState("");
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState<Message>();
  const [confirmDelete, setConfirmDelete] = useState(false)
  const baseUrl = import.meta.env.VITE_BASE_URL
  const [messages, setMessages] = useState<Message[]>();
  const token = useSelector((state: { auth: { token: string } }) => state.auth.token)
  const [session, setSession] = useState<boolean>(false)
  const [addModalOpen, setAddModalOpen] = useState<boolean>(false);
  const [cashierModalOpen, setCashierModalOpen] = useState<boolean>(false);
  const base_socket = import.meta.env.VITE_SOCKET;
  useLockBodyScroll(isModalOpen);
  const ResturantData = useSelector(
    (state: { resturant: { resturantData: ResturantData } }) =>
      state.resturant.resturantData,
  );

  const WithoutPlan = ResturantData?.subscription === null

  function toggleCashierMessageModal() {
    setCashierModalOpen(!cashierModalOpen);
  }
  const [whatsappLoading, setWhatsappLoading] = useState<boolean>(false);
  const [cashierCheck, setCashierCheck] = useState<boolean>(false);
  const whatsappEditor = useEditor({
    extensions: [
      StarterKit,
      Heading.configure({ levels: [1, 2, 3] }),
      Bold,
      BulletList,
      OrderedList,
      ListItem,
      Highlight.configure({ multicolor: true }),
      Placeholder,  // Placeholder extension for managing placeholders
    ],
    content: selectedMessage?.content || "",
    onUpdate: ({ editor }) => {
      if (!selectedMessage || !messages) return;

      // Tiptap handles the placeholders automatically now.
      const updatedMessages = messages.map((msg) =>
        msg.id === selectedMessage.id
          ? { ...msg, content: editor.getHTML() }
          : msg
      );

      setMessages(updatedMessages);
    },
  });







  useEffect(() => {
    if (!whatsappEditor) return;

    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Check if the clicked element is a <span> tag with the data-placeholder attribute
      if (target.nodeName === "SPAN" && target.dataset.placeholder) {
        // Remove the span (and its content) from the editor
        const updatedContent = whatsappEditor.getHTML().replace(target.outerHTML, "");

        // Set the updated content back to the editor
        whatsappEditor.commands.setContent(updatedContent, false);
      }
    };

    // Attach the click event listener to the editor DOM
    whatsappEditor.view.dom.addEventListener("click", handleClick);

    // Clean up the event listener when the component is unmounted
    return () => {
      whatsappEditor.view.dom.removeEventListener("click", handleClick);
    };
  }, [whatsappEditor]);



  // 🛠 Update content when selectedMessage changes
  useEffect(() => {
    if (whatsappEditor && selectedMessage) {
      whatsappEditor.commands.setContent(selectedMessage.content || "", false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMessage?.id]);


  const [qrImage, setQrImage] = useState<string | null>(null);
  function toggleAddModal() {
    setAddModalOpen(!addModalOpen);
  }

  const generateQRCode = async (qrData: string,) => {
    if (!qrData) {
      console.warn("QR data is empty.");
      setQrImage(null);
      return;
    }

    const qrCode = new QRCodeStyling({
      width: 500,
      height: 500,
      type: "svg",
      data: qrData, // Fix special character issues
      dotsOptions: { color: "#1b2b34", type: "rounded" },
      backgroundOptions: { color: "#ffffff" },
    });

    qrCode.getRawData("png").then((data) => {
      if (data) {
        const reader = new FileReader();
        reader.onload = () => setQrImage(reader.result as string);
        reader.readAsDataURL(data instanceof Blob ? data : new Blob([data]));
      } else {
        console.error("QR code generation failed.");
        setQrImage(null);
      }
    });
  };

  const addButton = () => {
    if (newMessageName === "") {
      toast.error(t("whatsappNotifier.pleaseEnterMessageName") as string);
      return
    }
    if (messages) {
      const newId = messages.length + 1;
      setMessages([
        ...messages,
        { id: newId, name: newMessageName, content: "", time: 10 },
      ]);
      toast.success(t("whatsappNotifier.messageAdded") as string);
      toggleAddModal();
      setNewMessageName("");
    }
  };
  function toggleSettings() {
    setSettingsOpen(!settingsOpen);
  }
  function toggleConfirmDelete() {
    setConfirmDelete(!confirmDelete);
  }
  async function getMessages() {
    try {
      const response = await axios.get(`${baseUrl}/api/dashboard/whatsapp-notifier/messages`, {
        headers: {
          Authorization: token,
        },
      });
      if (response.data.success == true) {
        const messages = response.data.messages.map((message: Message, index: number) => ({ ...message, id: index + 1 }))
        setMessages(messages);
        setSelectedMessage(messages[0]);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (!isModalOpen) return
    getMessages();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen]);
  async function saveMessages() {
    // Validate before making the request
    const invalid = messages?.some((msg) => {
      let hasError = false;

      if (!msg.content || msg.content.trim() === "") {
        toast.error(t("whatsappNotifier.messageEmpty") as string);
        hasError = true;
      }

      if (msg.time === 999 || msg.time === undefined) {
        toast.error(t("whatsappNotifier.messageTimeRequired") as string);
        hasError = true;
      }

      if (msg.event === "null" || msg.event === undefined || msg.event.trim() === "") {
        toast.error(t("whatsappNotifier.messageEventRequired") as string);
        hasError = true;
      }

      return hasError;
    });

    if (invalid) return;

    const toastId = toast.loading(t("whatsappNotifier.savingMessages") as string);
    try {
      const response = await axios.post(
        `${baseUrl}/api/dashboard/whatsapp-notifier/messages?locale=${i18n.language}`,
        messages,
        {
          headers: {
            Authorization: token,
          },
        }
      ).catch((error) => {
        return error.response;
      });

      if (response.data.success === true) {
        toast.success(t("whatsappNotifier.messagesSaved") as string);
      } else {
        toast.error(response.data.error);
      }
    } catch (error) {
      console.error(error);
      toast.error(t("whatsappNotifier.saveMessagesFailed") as string);
    } finally {
      toast.dismiss(toastId);
    }
  }

  function deleteMessage() {
    const toastId = toast.loading(t("whatsappNotifier.loading") as string);

    if (!messages || !selectedMessage) {
      toast.error(t("whatsappNotifier.messageNotFound") as string);
      return;
    }

    const index = messages.findIndex(msg => msg.id === selectedMessage.id);
    if (index !== -1) {
      messages.splice(index, 1);
      toast.success(t("whatsappNotifier.messagesSaved") as string);
    } else {
      toast.error(t("whatsappNotifier.messageNotFound") as string);
    }

    toast.dismiss(toastId);
    toggleConfirmDelete();
    toggleSettings();
  }
  async function getSession() {
    if (WithoutPlan) return
    try {
      const response = await axios.get(`${baseUrl}/api/dashboard/whatsapp-notifier/status`, {
        headers: {
          Authorization: token,
        },
      });

      if (response.data.success === true) {
        if (response.data.data.handshaked === true) {
          setSession(true);

          // if (handshakeDataObject?.sessionId === response.data.sessionId) {
          //   setSession(true);
          // }else{
          //   setSession(false);
          // }

        } else {
          getQr();

        }



      }

      else {
        setSession(false);
      }
    } catch (error) {
      console.error(error);
      toast.error(t("whatsappNotifier.createSessionFailed") as string);
    }
  }


  async function getQr() {
    if (!isModalOpen) return // Return handshakeId
    const toastId = toast.loading(t("whatsappNotifier.loading") as string);
    const socket = new WebSocket(`${base_socket}/socket/dashboard/whatsapp-notifier/handshake`);
    socket.addEventListener('open', () => {
      socket.send(JSON.stringify({
        "type": "authorize",
        "token": token
      }));
    })
    socket.addEventListener('message', (e) => {
      try {
        const data = JSON.parse(e.data);
        if (data.success === true) {
          if (data.qr) {
            generateQRCode(data.qr);
            toast.success(t("whatsappNotifier.scanQRCode") as string);
          } else if (data?.data?.handshaked === true) {
            setSession(true);
            toast.success(t("whatsappNotifier.sessionCreated") as string);
          }
        } else {
          toast.error(data.error || t("whatsappNotifier.createSessionFailed") as string);
        }
      } catch (error) {
        console.error(error);

        toast.error(t("whatsappNotifier.createSessionFailed") as string);
      } finally {
        toast.dismiss(toastId)
      }
    })

  }
  async function getWhatsappMessage() {
    if (WithoutPlan) return
    try {
      const options = {
        url: `${baseUrl}/api/dashboard/whatsapp-notifier/cashier?locale=${i18n.language}`,
        method: "GET",
        headers: {
          Authorization: token,
        },
      }
      const response = await axios(options);
      if (response.data.success === true) {
        if (response.data.enabled === true) {
          setCashierCheck(true)
        } else {
          setCashierCheck(false)
        }


      }
    } catch (error) {
      console.error(error);

    }
  }
  async function toggleWhatsappMessages() {
    const toastId = toast.loading(t("whatsappNotifier.loading") as string);
    setWhatsappLoading(true)
    try {
      const options = {
        url: `${baseUrl}/api/dashboard/whatsapp-notifier/cashier?locale=${i18n.language}`,
        method: "POST",
        headers: {
          Authorization: token,
        },
        data: {
          enabled: !cashierCheck
        }
      }
      const response = await axios(options);
      if (response.data.success === true) {

        toast.success(t("whatsappNotifier.updatedSuccessfully") as string);

      } else {
        toast.error(t("whatsappNotifier.updateFailed") as string);
      }
    } catch (error) {
      console.error(error);

    } finally {
      toast.dismiss(toastId)
      setWhatsappLoading(false)
    }
  }
  useEffect(() => {
    getWhatsappMessage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen, whatsappLoading, cashierModalOpen])
  useEffect(() => {
    if (!app.installed) return
    getSession()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen])
  return (
    <>

      <div
        key={app.name}
        className="whatsapp-card relative flex flex-col gap-5 overflow-hidden rounded-lg border bg-white p-5"
      >
        <div className="card-head flex items-center justify-between">
          {/* image */}
          <div className="flex items-center gap-5">
            <div className="w-14">
              <img src={app.image} alt="app image" className="w-full" />
            </div>
            {app.installed && session === true ?
              <div className="flex gap-2 items-center py-1 px-2 bg-green-200 rounded-md text-green-600 border-2 border-green-600">
                <span className="text-sm"> {t("whatsappNotifier.connected")}</span>
                <FaWifi className="text-sm" />
              </div>
              : app.installed && session === false && !WithoutPlan ?
                <div className="flex gap-2 items-center py-1 px-2 bg-red-200 rounded-md text-red-600 border-2 border-red-600">
                  <span className="text-sm">  {t("whatsappNotifier.disconnected")}</span>
                  <MdOutlineWifiOff className="text-sm" />
                </div>
                : null}
          </div>

          {/* badge */}
          {WithoutPlan ? (
            <span
              className={`absolute top-[20px] w-[8rem] bg-sidebar py-1 text-center font-semibold text-skyblue ${i18n.language === "ar" ? "end-[-30px] rotate-[-45deg]" : "end-[-30px] -rotate-[-45deg]"
                }`}
            >
              {t("subscribtionSettings.pro")}
            </span>
          ) : !app.available ? (
            <span
              className={`absolute top-[20px] w-[8rem] bg-[#ffc62a] py-1 text-center font-semibold text-[#907017] ${i18n.language === "ar" ? "end-[-30px] rotate-[-45deg]" : "end-[-30px] -rotate-[-45deg]"
                }`}
            >
              {t("apps.soon")}
            </span>
          ) : app.installed ? (
            <span
              className={`absolute top-[20px] w-[8rem] bg-green-400 py-1 text-center font-semibold text-green-700 ${i18n.language === "ar" ? "end-[-30px] rotate-[-45deg]" : "end-[-30px] -rotate-[-45deg]"
                }`}
            >
              {t("apps.active")}
            </span>
          ) : (
            <span
              className={`absolute top-[20px] w-[8rem] bg-gray-400 py-1 text-center font-semibold text-gray-600 ${i18n.language === "ar" ? "end-[-30px] rotate-[-45deg]" : "end-[-30px] -rotate-[-45deg]"
                }`}
            >
              {t("apps.inactive")}
            </span>
          )}
        </div>

        <div className="font-bold text-gray-500">
          {i18n.language === 'ar' ? app.titleAR : app.titleEN}
        </div>
        <p className="text-slate-500">
          {i18n.language === 'ar' ? app.descriptionAR : app.descriptionEN}
        </p>

        {app.static || WithoutPlan ? null : app.available === false ? null : app.installed ? (
          <div className="flex items-center justify-between">
            {/* uninstall app */}
            <button
              disabled={isPending}
              onClick={() => uninstallApp(app.name)}
              className="mt-1 self-end rounded-md bg-red-500 px-3 py-2 text-white disabled:cursor-not-allowed disabled:bg-gray-500 disabled:text-gray-300"
            >
              {t("whatsappNotifier.uninstall")}
            </button>

            {/* Modal Button */}
            <button
              disabled={isPending}
              onClick={() => setIsModalOpen(true)}
              className="mt-1 self-end rounded-md bg-sidebar px-3 py-2 text-skyblue disabled:cursor-not-allowed disabled:bg-gray-500 disabled:text-gray-300"
            >
              {t("whatsappNotifier.configure")}
            </button>
          </div>
        ) : (
          <button
            disabled={isPending}
            onClick={() => installApp(app.name)}
            className="self-end rounded-md bg-green-500 px-3 py-2 text-white disabled:cursor-not-allowed disabled:bg-gray-500 disabled:text-gray-300"
          >
            {t("whatsappNotifier.install")}
          </button>
        )}
      </div>
      {addModalOpen && (
        <div className="fixed inset-0 z-[99999] flex items-start justify-center bg-black/50 pt-[70px]">
          <div className="bg-white relative w-fit mt-28 rounded-md p-5">
            <IoMdClose size={24} className="text-red-600 absolute top-2 end-2 cursor-pointer" onClick={toggleAddModal} />
            <h3 className="text-sidebar text-xl font-semibold" > {t("whatsappNotifier.addMessage")}</h3>
            <div className="mt-10 flex-col flex gap-2">
              <label> {t("whatsappNotifier.messageName")}</label>
              <input type="text" value={newMessageName} onChange={(e) => setNewMessageName(e.target.value)} className="border py-1 px-4 rounded" />
            </div>
            <button onClick={addButton} className="my-btn mt-5">{t("whatsappNotifier.add")}</button>
          </div>
        </div>
      )}
      {/* settings Modal */}
      {settingsOpen && (
        <div className="fixed inset-0 z-[99999] flex items-start justify-center bg-black/50 pt-[70px]">
          <div className="bg-white relative w-fit mt-28 rounded-md p-5">
            <IoMdClose size={24} className="text-red-600 absolute top-2 end-2 cursor-pointer" onClick={toggleSettings} />
            <div className="text-center text-xl font-bold">{t("whatsappNotifier.messageSettings")}</div>

            <div className=" mt-10">
              <h3 className=" ms-10 font-semibold">{t("whatsappNotifier.editMessageName")}</h3>
              <div className="flex items-center gap-5">
                <input type="text" defaultValue={selectedMessage?.name} onChange={(e) => {
                  if (!selectedMessage || !messages) return
                  selectedMessage.name = e.target.value
                  setMessages([...messages])
                }} className=" border px-2 py-2 rounded" />

              </div>
            </div>
            <div className="mt-5 flex items-center justify-center gap-5">
              {selectedMessage?.id !== 1 &&
                <button onClick={toggleConfirmDelete} className="text-white bg-red-500 w-fit px-5 py-1 rounded-md">{t("whatsappNotifier.delete")}</button>
              }
              <button onClick={toggleSettings} className="bg-sidebar text-white rounded-md w-fit px-5 py-1">{t("whatsappNotifier.save")}</button>
            </div>
          </div>


        </div>
      )}
      {cashierModalOpen && <WhatsappMessage cashierModalOpen={cashierModalOpen} toggleCashierMessageModal={toggleCashierMessageModal} />}
      {confirmDelete && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50 ">
          <div className="bg-white relative w-fit flex flex-col gap-5 rounded-md p-5">
            <IoMdClose size={24} className="text-red-600 absolute top-2 end-2 cursor-pointer" onClick={toggleConfirmDelete} />
            <div className="text-center text-xl font-bold">{t("whatsappNotifier.deleteMessage")}</div>
            <p className="text-center">{t("whatsappNotifier.confirmDeleteMessage")}</p>
            <div className="flex justify-center gap-5">
              <button onClick={toggleConfirmDelete} className="my-btn w-fit px-5 py-2">{t("whatsappNotifier.cancel")}</button>
              <button onClick={() => {
                deleteMessage()
              }} className="bg-red-500 text-white rounded-md w-fit px-5 py-2">{t("whatsappNotifier.delete")}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 z-[9999] px-5 flex items-start justify-center bg-black/50 pt-10"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex  max-h-[90vh] min-h-[50vh] lg:max-w-[50%] md:max-w-[70%] flex-col gap-3 rounded-lg bg-white px-4 py-3 pb-5 shadow-lg sm:px-5 sm:py-5 ">
            {/* Modal header */}
            {session ? <>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 text-sm font-semibold sm:text-base md:text-2xl">
                  <FaWhatsapp className="text-2xl" />
                  <h2 className="text-lg">
                    {t("whatsappNotifier.configureNotifier")}
                  </h2>
                </div>
                <button
                  onClick={() => {
                    setIsModalOpen(false);
                  }}
                  className="text-gray-600 hover:text-gray-800"
                >
                  <IoMdClose size={24} className="text-red-600" />
                </button>
              </div>
              <div className="font-semibold text-sidebar">
                {t("whatsappNotifier.enableWhatsappCashier")}
              </div>
              <div className="flex items-center gap-10 pb-2">
                <div className="">
                  <ToggleSwitch
                    size="small"
                    checked={cashierCheck}
                    onChange={toggleWhatsappMessages}
                    disabled={whatsappLoading}
                  />
                </div>
                {cashierCheck && <button onClick={toggleCashierMessageModal} className="bg-sidebar text-skyblue px-2 text-sm py-1 rounded">{t("whatsappNotifier.cashieropenMessages")}</button>
                }
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={toggleAddModal}
                  className="bg-sidebar text-skyblue px-2 text-sm py-1 rounded"
                >
                  {t("whatsappNotifier.addMessage")}
                </button>
              </div>
              {/* Modal Body Content */}
              <div className="w-full flex overflow-x-auto overflow-y-hidden thin-scrollbar whitespace-nowrap gap-2 py-3  px-2 items-center">
                {messages?.map((message) => (
                  <button
                    onClick={() => setSelectedMessage(message)}
                    key={message.id}
                    className={` ${selectedMessage?.id === message.id ? "border-b-2" : "text-sidebar"} relative px-5 border-sidebar`}
                  >
                    {message.name}
                    <FaGear onClick={() => {

                      toggleSettings()
                    }} className="absolute text-[12px] top-1.5 end-1" />
                  </button>
                ))}

              </div>
              {messages && messages?.length > 0 ?

                <div className="thin-scrollbar flex-1 flex flex-col gap-2  h-full w-full overflow-y-auto p-1">
                  <div className="w-full rounded-md flex flex-col gap-3  p-5 flex-1 h-full border">
                    <div className="flex flex-wrap gap-5">
                      <div className="flex flex-col gap-2">
                        <label>{t("whatsappNotifier.chooseAction")}</label>
                        <div className="rounded-xl overflow-hidden border w-fit">
                          <select
                            value={selectedMessage?.event}
                            onChange={(e) => {
                              if (!selectedMessage || !messages) return;
                              selectedMessage.event = e.target.value;
                              setMessages([...messages]); // Trigger a re-render with the updated messages


                            }}
                            className="px-5 py-1"
                          >
                            <option value="null">{t("whatsappNotifier.choose")}</option>
                            <option value="order-placed">{t("whatsappNotifier.orderPlaced")}</option>
                            <option value="order-accepted">{t("whatsappNotifier.orderAccepted")}</option>
                            <option value="order-preparing">{t("whatsappNotifier.orderPreparing")}</option>
                            <option value="order-finished">{t("whatsappNotifier.orderFinished")}</option>
                            <option value="order-delivered">{t("whatsappNotifier.orderDelivered")}</option>
                            <option value="order-rejected">{t("whatsappNotifier.orderRejected")}</option>
                          </select>
                        </div>
                      </div>
                      <div className="flex flex-col gap-2">
                        <label>{t("whatsappNotifier.chooseMessageTime")}</label>
                        <div className="rounded-xl overflow-hidden border w-fit">
                          <select value={selectedMessage?.time} onChange={(e) => {
                            if (!selectedMessage || !messages) return
                            selectedMessage.time = parseInt(e.target.value)
                            setMessages([...messages])
                          }} className="px-5 py-1">
                            <option value="999">{t("whatsappNotifier.chooseMessageTime")}</option>
                            <option value="0">{t("whatsappNotifier.instantly")}</option>
                            <option value="1">{t("whatsappNotifier.1Min")}</option>
                            <option value="5">{t("whatsappNotifier.5Min")}</option>
                            <option value="10">{t("whatsappNotifier.10Min")}</option>
                            <option value="15">{t("whatsappNotifier.15Min")}</option>
                            <option value="30">{t("whatsappNotifier.30Min")}</option>
                            <option value="60">{t("whatsappNotifier.60Min")}</option>
                          </select>
                        </div>
                      </div>

                    </div>
                    <Toolbar editor={whatsappEditor} />
                    <EditorContent editor={whatsappEditor} className="tiptap-editor" />
                  </div>



                  <button onClick={saveMessages} className="my-btn">  {t("whatsappNotifier.save")}

                  </button>
                </div>
                : <Skeleton className="dark:bg-gray-400 h-[300px] w-[500px] mx-auto" />}
            </> :
              <div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3 text-sm font-semibold sm:text-base md:text-2xl">
                    <FaWhatsapp className="text-2xl" />
                    <h2 className="text-lg">
                      {t("whatsappNotifier.enableWhatsappCashier")}                    </h2>
                  </div>
                  <button
                    onClick={() => {
                      setIsModalOpen(false);
                    }}
                    className="text-gray-600 hover:text-gray-800"
                  >
                    <IoMdClose size={24} className="text-red-600" />
                  </button>
                </div>
                <div className="flex items-center justify-center gap-5 flex-col mt-10">
                  <div>{t("whatsappNotifier.scanQRCodeLogin")}</div>


                  <div className="w-[250px] h-[250px]">{qrImage ? <img src={qrImage} alt="" className="w-full h-full" /> : <Skeleton className="w-full h-full dark:bg-slate-600" />}</div>
                </div>
              </div>}
          </div>
        </div >
      )
      }
    </>
  );
}

export default WhatsAppNotifierApp;


// <textarea value={selectedMessage?.content} onChange={(e) => {
//   if (!selectedMessage || !messages) return
//   selectedMessage.content = e.target.value
//   setMessages([...messages])
// }} className="w-full h-full min-h-[200px] max-h-[300px] p-2 border rounded-md border-sidebar"></textarea>